var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCityOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03352 5.04244V17.3949C8.90712 17.3413 9.81744 17.3109 10.7533 17.3062L10.7483 6.97664L9.07967 5.52384L9.07672 2.87674L11.8661 0.5V17.313C12.0027 17.3154 12.5189 17.3183 12.6544 17.3217V12.3314L14.3237 11.2931V6.18693L16.7612 8.51864L16.7572 12.0868L15.5005 11.1995L15.4498 17.5108C16.1519 17.5783 16.8229 17.6611 17.4558 17.7579V13.7547L18.6269 14.5265V17.9613C20.7866 18.3842 21.571 18.6576 22.2094 19.3445C16.3602 17.5408 5.92255 17.5389 0.0668945 19.3445C0.843946 18.5086 1.93934 18.1291 4.85534 17.7121L4.83926 7.10072L8.03352 5.04244Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityOutlined);
export default __webpack_public_path__ + "static/media/city-outlined.44691936657ce904658ea1ab17e24f03.svg";
export { ForwardRef as ReactComponent };